/**
 * Server-side structured data for the HomeBuyingTimeline tool page.
 * Lives in a data module (not the page component) so routeMeta can emit it
 * into the server HTML; react-helmet would only add it after hydration.
 */
import { FAQS, PHASES } from "@/components/tools/homeBuyingTimelineData";

export const PAGE_URL = "https://www.homeapproach.com/tools/home-buying-timeline";

  export const HOME_BUYING_TIMELINE_JSON_LD: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      name: "Home Buying Timeline: Every Step From Pre-Approval to Closing Day",
      description:
        "A realistic list of every step in the homebuying process, from credit check and pre-approval through inspection, appraisal, underwriting, title, and closing day, with typical durations and common delays.",
      url: PAGE_URL,
      inLanguage: "en-US",
      isPartOf: { "@type": "WebSite", name: "Home Approach", url: "https://www.homeapproach.com" },
      publisher: {
        "@type": "Organization",
        name: "Home Approach",
        url: "https://www.homeapproach.com",
        logo: { "@type": "ImageObject", url: "https://www.homeapproach.com/og-image.png" },
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
        { "@type": "ListItem", position: 2, name: "Tools", item: "https://www.homeapproach.com/tools" },
        {
          "@type": "ListItem",
          position: 3,
          name: "Home Buying Timeline: Every Step From Pre-Approval to Closing Day",
          item: PAGE_URL,
        },
      ],
    },
    {
      "@type": "HowTo",
      name: "Home Buying Timeline: Every Step From Pre-Approval to Closing Day",
      description:
        "The complete chronological homebuying process in 20 steps across five phases, from pre-work through closing day.",
      totalTime: "P150D",
      step: PHASES.flatMap((phase) =>
        phase.steps.map((s) => ({
          "@type": "HowToStep",
          position: s.n,
          name: s.title,
          text: s.body,
          url: `${PAGE_URL}#${phase.id}`,
        }))
      ),
    },
    {
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};
